// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './plugins/element.js'
// 自定义指令
import directives from './directive'

import 'babel-polyfill'

import service from '@/utils/request'

import echarts from 'echarts'

const isDebugMode = process.env.NODE_ENV !== 'production'

Vue.config.debug = isDebugMode
Vue.config.devtools = isDebugMode
Vue.config.productionTip = false

Vue.prototype.$http = service
Vue.prototype.$echarts = echarts
// 注册全局自定义指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

Vue.filter('price', function (value) {
  return Number(value).toFixed(2)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js